import formatDate from './format-date';
export default formatDate;
